import { useQuery } from "@tanstack/react-query";
import api from "../../axios";

export const useUserInfor = () => {
  return useQuery({
    queryFn: () => api.get("/users/me"),
    queryKey: ["user_info"],
    meta: {
      errorMessage: "Failed to fetch user",
    },
  });
};

export const useVerifyEmail = (token) => {
  return useQuery({
    queryFn: () => api.get(`/users/verify?token=${token}`),
    queryKey: ["verify_email"],
    meta: {
      errorMessage: "Failed to verify user"
    }
  });
};



export const updateUser = async (data) => {
  const response = await api.patch("/users", data);
  return response.data;
};

export const verifyClerkUser = async (session_id) => {
  const response = await api.post(`/o_auth?session_id=${session_id}`);
  return response.data;
};

export const login = async (data) => {
  const response = await api.post("/login", data);
  return response.data;
};

export const register = async (data) => {
  const response = await api.post("/users", data);
  return response.data;
};

export const serverLogout = async () => {
  const response = await api.post("/logout");
  return response;
};
